<template>
<span v-if="showSearchInput" class="wrapper">
    <!-- <transition enter-active-class="fadeIn animated faster" leave-active-class="fadeOut animated faster"> -->
		<div class="extra-space"></div>
    	<div id="searchBox" v-if="showSearchInput" v-on-clickaway="closeOverlay" class="search_ui_box" key="searchInput">
			<div class="sub_top"
			:class="{'border-search-open':showSearchSuggest && searchSuggestions.length > 0}"
			@click="displayShowSearchSuggest" >
				<div class="sub_icon">
					<img id="searchIcon" @click="search()"  src="/img/green_search.svg">
				</div>
			
				<input  
					id="searchInput" 
					type="text" 
					v-focus
					autocomplete="off"
					v-model="searchInput" 
					@keydown="keyDownOnSearchInput"
					class="sub_search_input"
					spellcheck="false"
				>
				<img v-if="!isIE" class="keyboard_icon" @click="displayKeyboard()" src="/img/np_keyboard.svg" >
			</div>
		<div v-show="showSearchSuggest"  :class="{'sub_bottom':searchSuggestions.length > 0}" key="searchSugg">
				<ul tabindex="0"  v-show="searchSuggestions.length > 0" id="searchSugg">
					<!-- <transition-group enter-active-class="slideInDown animated" > -->
					 <!--  -->
							<li class="sub_suggest" 
								v-for="(sugg,index) in searchSuggestions" :key="index" v-html="sugg"
								@click="search(sugg)"
								:id="'search_' + index"
								tabindex="-1"
								:class="{'sub_suggest-current':currentId == 'search_' + index.toString()}"
							></li>
					<!-- </transition-group> -->
				</ul>
			</div>
		</div>
		<div class="extra-space"></div>
    <!-- </transition> -->
	
    <custom-keyboard 
		v-if="showKeyboard" 
		:input="searchInput"
		@onChangeInput="onChange"
		@enterClicked="search()"
		id="keyboard"
	/>
	
</span>
</template>

<script>
import * as SwiftypeAppSearch from 'swiftype-app-search-javascript';
import CustomKeyboard from "../keyboard/CustomKeyboard";
import {mixin as clickAway} from "vue-clickaway";
import {removeDisturbingElm,addDisturbingElm} from '../../mixins/manageDisturbingElm'
export default {
	components:{CustomKeyboard},
	mixins:[clickAway],
	name:"search",
    data(){
        return{
			isIE : /*@cc_on!@*/false || !!document.documentMode,
			client:null,
			searchInput:"",
			showKeyboard:false,
			showSearchInput:false,
			showSearchSuggest:false,
			searchSuggestions:[],
			immediate:true,
			later:false,
			watchSearchInput:true,
			currentId:''
        }
    },
    methods:{
		keyDownOnSearchInput(e){
			if(e.keyCode == 40){
				this.arrowDown(e)
			}
			else if(e.keyCode == 38){
				this.arrowUp(e)
			}
			else if(e.keyCode == 13){
				this.$el.querySelector("#searchInput").blur()
				this.search()
			}	
			else{
				this.currentId = ''
				this.initiateSearchRequest()
			}
		},
		keyDownOnKeyboard(e){
			if(this.showKeyboard && (e.target.id != "searchInput" || e.target.parentNode.id != "searchSugg")){
				if(e.keyCode == 13){
					this.search();
				}
				if(e.keyCode == 40 || e.keyCode == 38){
					e.preventDefault()
					this.$el.querySelector("#searchInput").focus();
				}
			}
		},
		arrowDown(e){
			e.preventDefault()
			if(!this.currentId){
				this.$el.querySelector("#search_" + '0') ? 
					this.currentId = 'search_' + '0'
					:''
			}else{
				let next = parseInt(this.currentId.substring(7)) + 1;
				next.toString();
				this.$el.querySelector("#search_" + next) ?
					this.currentId = "search_" + next
					:''
			}
		},
		arrowUp(e){
			e.preventDefault()
			if(this.currentId){
				if(this.currentId == 'search_0'){
					this.currentId = ''
				}else{
					let prev = parseInt(this.currentId.substring(7)) - 1;
					prev.toString();
					this.currentId = "search_" + prev
				}	
			}
		},
		closeOverlay($event){
			let targetId = event.target.id;
			let offsetParentId = _.get(event.target.offsetParent,'id');
			
			if(offsetParentId != undefined){			
				let ParentId = event.target.offsetParent.id;				
				if(ParentId !== "simple-keyboard" && ParentId !=="header" && targetId !== "account" && targetId !== "assistance"){
				this.$parent.closeOverlay() 
				}	
				if(ParentId !== "simple-keyboard"){
					this.hideSearch();
				}
			}else{	
				if(targetId !== "account" && targetId !== "assistance"){		
					this.$parent.closeOverlay()
				}			
			}	
		},
		onChange(input){   
			this.searchInput = input;
			this.initiateSearchRequest()
		},
		displayKeyboard(){
			this.showKeyboard = !this.showKeyboard;
		},
		displaySearchInput(){
			this.showSearchInput = true;
		},
		displayShowSearchSuggest($event){
			if(event.target.id !== "searchIcon"){
				this.$emit("showOverlay");
				this.showSearchInput = true;
				this.showSearchSuggest = true;

				let searchInputElm = document.getElementById('searchInput')
				if(searchInputElm){searchInputElm.focus()}
			}
		},
		hideSearch(){
			if(this.searchInput){
					this.showKeyboard = false;
					this.showSearchSuggest = false;
			}else{
				this.hideShowSearchSuggest();
				this.showKeyboard = false;
			}
		},
		hideShowSearchSuggest(){
			this.showSearchInput = false;
			this.showSearchSuggest = false;
		},
		requestSearchSuggest(){
				this.client.querySuggestion(this.searchInput, {
				size: 7,
				types: {
					documents: {
						fields: ['title', 'vendor', 'description', 'creators'],
					},
					}
				})
				.then(response => {
					if(!this.searchInput){
						this.searchSuggestions = []
						return
					}
					this.searchSuggestions = response.results.documents.map(s=> s.suggestion);
					
				})
				.catch(error => {
					console.log(`error: ${error}`);
				});
		},
		initiateSearchRequest(){
			this.later = !this.immediate;
				if(this.immediate){
					this.immediate = false;
					this.requestSearchSuggest();
					setTimeout(()=>{
						this.immediate = true;
						if(this.later){
							this.requestSearchSuggest();
						}
					},250)
				}
		},
		search(sugg = null){
			sugg ? this.searchInput = sugg :''
			if(!this.searchInput)return
			
			this.currentId = ''
			this.searchSuggestions = [];
			this.$parent.closeOverlay();

			this.$router.push({
				path:"/search",
				query:{q:this.searchInput}
			}).catch(err=>{});
		},
	},
    inject:["keyboardEvents"],
    mounted(){
		this.client = SwiftypeAppSearch.createClient({
						hostIdentifier: 'host-brm4vh',
						searchKey: 'search-wszrwfhg6m16ncx4ism9nmix',
						engineName: 'shopeichlers'	
				});
		document.addEventListener('keydown',this.keyDownOnKeyboard)
	},
	beforeDestroy(){
		this.$parent.showSearchInput = false
	},
	watch:{
		showSearchInput(newVal){
			if(newVal){
				this.$emit("inputOpen");
			}else{this.$emit("inputClosed");}
		},
		currentId(){
			if(this.currentId){
				this.searchInput = this.$el.querySelector(`#${this.currentId}`).innerText
			}
		},
	}
}
</script>

<style scoped>
.faster{
	animation-duration: 250ms;
}
.keyboard_icon:hover{
	cursor: pointer;
}
.sub_suggest-current {
    background: var(--gold_shade);
		outline-style: none !important;
  	outline: none !important;
}
.sub_suggest{
	outline: none;
}
.wrapper{
	display: flex;
    justify-content: space-between;
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    top: 0;
    height: 100px;
	align-items: center;
	pointer-events: none;
}
.extra-space{
	min-width: 320px;
    height: 100px;
}
.search_ui_box{
    height: 55px;
	position: relative;
	top: 0;
	left:0;
	border:initial;
	pointer-events: initial;
	width: 650px;
	margin-left: 52px;
}
.sub_top{
	border: 1px solid var(--gold);
}
.sub_bottom{
	width: 100%;
	background: #F9F6F4;
	border: 1px solid var(--gold);
	border-top:initial;
	border-top: 1px solid var(--gold_outline);
}
.border-search-open{
	border-bottom: var(--gold_outline);
}
@media only screen and (max-width: 959px){
	.wrapper{
		height: 68px;
	}
	.extra-space{
		min-width: 250px;
		height: 68px;
	}
	.search_ui_box{
		height: 50px;
		pointer-events: initial;
		width: 350px;
		margin-left: initial;
	}
	.sub_top{
		height: inherit;
	}
}

</style>



// WEBPACK FOOTER //
// resources/js/components/layouts/Search.vue